import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { DiscountCreationRequest } from "../../../apis/ersys-data"
import { Grid } from "@mui/material"
import { useEffect, useState } from "react"
import FormInputText from "../../../components/forms/FormInputText"
import { useForm } from "react-hook-form"

const defaults: DiscountCreationRequest = {
  code: "",
  description: "",
}

interface DiscountCreationModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (req: DiscountCreationRequest) => Promise<void>
}

const DiscountCreationModal: React.FC<DiscountCreationModalProps> = ({
  open,
  onCreate,
  onClose,
}) => {
  const [formSpacing] = useState(2)
  const { handleSubmit, reset, control } =
    useForm<DiscountCreationRequest>({
      defaultValues: defaults,
      reValidateMode: "onSubmit",
    })

  const handleCreate = (input: DiscountCreationRequest) => {
    onCreate(input)
  }

  useEffect(() => {
    reset()
  }, [reset, open])

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="alert-dialog-title">Create Discount Code</DialogTitle>
      <DialogContent>
        <form>
          <Grid container spacing={2}>
            <Grid xs={12} item>
              <FormInputText
                spacing={formSpacing}
                name={"code"}
                control={control}
                label={"Code"}
                rules={{ required: "Required Field", maxLength: 25 }}
              />
              <FormInputText
                spacing={formSpacing}
                name={"description"}
                control={control}
                label={"Description"}
                rules={{ required: "Required Field", maxLength: 50 }}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(handleCreate)} autoFocus>
          Ok
        </Button>
        <Button onClick={() => onClose()} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DiscountCreationModal
